module.exports = __webpack_public_path__ + "static/media/google_Analytics_integration.a1bcb0d9.PNG";